<div class="building-report-footer d-print-block d-none">
  @if (showLogo()) {
    <div class="container">
      @if (date(); as dateValue) {
        <span class="me-auto">{{ dateValue | date: 'longDate' }}</span>
      }
      Powered by
      <a rel="noopener noreferrer" target="_blank" href="https://cfp.nl">
        <img src="./assets/img/csr-logo-report.png" alt="CFP GREEN BUILDINGS" />
      </a>
    </div>
  }
</div>
